/**
 * File environment-check.js.
 * Swaps login/enrollment link hrefs for pre-prod environments
 */

function setLink(els, path) {
  const link = getMemberDomain() + path;
  for (let i = 0; i < els.length; i++) {
    let el = els[i];
    el.setAttribute('href', link);
  }
}

// Init
if (isPreProd()) {
  const enrollEls = document.querySelectorAll('a[href*="member.chime.com/enroll"]');
  const signInEls = document.querySelectorAll('a[href*="member.chime.com/users/sign_in"]');
  setLink(enrollEls, '/enroll/');
  setLink(signInEls, '/users/sign_in');
}
